/*
 * @Descripttion:
 * @Author: 老板说这个需求很简单
 * @Date: 2025-05-16 21:07:39
 * @LastEditTime: 2025-09-12 09:49:46
 * @LastEditors: sudo_rm_rf
 */
import Layout from '/@/layout/index.vue';
export const baseRouter = [
  {
    path: '/redirect',
    component: Layout,
    // hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('/@/views/redirect/index.vue'),
      },
    ],
  },
  {
    path: '',
    redirect: '/login',
  },

  {
    path: '/login',
    component: () => import('/@views/login/index.vue'),
  },
  {
    path: '/voiceMark',
    component: () => import('/@views/voiceMark/index.vue'),
  },
  {
    path: '/voiceMark/cough',
    component: () => import('/@views/voiceMark/cough.vue'),
  },
  {
    path: '/testVoiceMark',
    component: () => import('/@views/voiceMarkTest/index.vue'),
  },

  {
    path: '/test',
    // component: () => import('/@views/test/ogl/index.vue'),
    // component: () => import('/@views/test/splashCursor/index.vue'),
    // component: () => import('/@views/test/unocss/index.vue'),
    // component: () => import('/@views/test/tsx/index.vue'),
    // component: () => import('/@views/test/indexDB/index.vue'),
    // component: () => import('/@views/test/scan/index.vue'),
    component: () => import('/@views/test/wavesurfer/index.vue'),
  },
  {
    path: '/404',
    component: () => import('/@views/container/404.vue'),
    name: '404',
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
];
